import heydoctor from 'app/vendor/heydoctor';
import { Pharmacy } from 'app/types';
import { Stores, Store } from 'app/lib/synaptik';

interface State {
  records: Pharmacy[];
  detail: null | Pharmacy;
  fetchingList?: boolean;
}

interface FetchListProps {
  visitId: number;
  visitPrescriptionId?: number;
  search?: string;
  address?: string;
  limit?: number;
  big5?: number;
}

export class PharmaciesStore extends Store<State, Stores> {
  state: State = {
    records: [],
    detail: null,
  };

  fetchList = ({ visitId, visitPrescriptionId, limit = 25, search, address, big5 }: FetchListProps) =>
    this.runAsync({
      key: 'fetchingList',
      work: async (): Promise<Pharmacy[]> => {
        const pharmacies: Pharmacy[] = (await heydoctor.pharmacies.fetchList({
          search,
          address,
          limit,
          visit_id: visitId,
          visit_prescription_id: visitPrescriptionId,
          big5,
        })) as any;

        this.setState({
          records: pharmacies,
        });

        // @ts-ignore
        return pharmacies;
      },
    });
}
